import type { QuestionType} from "@/lib/gql/__generated__/graphql";
import { type QuestionItemInput } from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { QuestionPreQuestionItem } from "./pre-question-item";
import { QuestionCardItem } from "../../../system/question/card/card-item";

export type QuestionPreQuestionRowProps = {
	question: ForAutoGenerator<QuestionItemInput, "">;

	remove: () => void;
	onSetIsRequired: (isRequired: boolean) => void;
	onSetTitle: (input: string) => void;
	onSetQuestionType: (questionType: QuestionType) => void;

	appendOptionItem: () => void;
	removeOptionItem: (optionIndex: number) => void;

	onSetOptionItem: (optionIndex: number) => (input: string) => void;
};

/** 並べ替えなしの1行（カード枠＋フォーム）。複数件でDnDする場合は `SortablePreQuestionRow` を使う。 */
export const QuestionPreQuestionRow = ({
	question,
	remove,
	onSetIsRequired,
	onSetTitle,
	onSetQuestionType,

	appendOptionItem,
	removeOptionItem,

	onSetOptionItem,
}: QuestionPreQuestionRowProps) => {
	return (
		<QuestionCardItem removeItem={remove}>
			<QuestionPreQuestionItem
				question={question}
				onSetIsRequired={onSetIsRequired}
				onSetTitle={onSetTitle}
				onSetQuestionType={onSetQuestionType}
				appendOptionItem={appendOptionItem}
				removeOptionItem={removeOptionItem}
				onSetOptionItem={onSetOptionItem}
			/>
		</QuestionCardItem>
	);
};

QuestionPreQuestionRow.displayName = "QuestionPreQuestionRow";
